import React from "react";
import ReactHtmlParser from "react-html-parser";
import LazyLoad from "react-lazyload";

const PLPInnerBanner = ({idx, plpMode, filtersHiddenDesktop}) => {
    const plpCollectionSlug = window.initialCollectionSlug;
    const plpInnerBanners = window.collectionInnerBannersDynamic;
    let innerBannerOffset = 0;
    let generatedBanner = null;

    if (!plpInnerBanners || !plpMode) { return null; }

    plpInnerBanners.forEach((collectionBanners) => {
        if (plpCollectionSlug === collectionBanners.collection_handle) {
            const collectionInnerBanners = collectionBanners.inner_banners;

            collectionInnerBanners.forEach((innerBanner) => {
                if (filtersHiddenDesktop) {
                    innerBannerOffset += 2;
                }

                if (idx === parseFloat(innerBanner.banner_insert_location) + innerBannerOffset) {
                    let banner_text_location_class = '';
                    let stripped_title_label = ReactHtmlParser(innerBanner.title_label);

                    if (innerBanner.text_location === "center" || !innerBanner.image_url) {
                        banner_text_location_class = ' collection-inner-banner--no-image';
                    } else if (innerBanner.text_location === "left") {
                        banner_text_location_class = ' collection-inner-banner__left-image';
                    }

                    generatedBanner = <div className={`collection-inner-banner ${innerBanner.only_image === "true" ? ' collection-inner-banner__one-image' : ''} ${banner_text_location_class}`}>
                        <a href={innerBanner.url} className="plp__collection-inner-banner-link" target="_blank" rel="noopener noreferrer">
                            {innerBanner.only_image === "true" &&
                            <LazyLoad height={200} offset={100} once={true}>
                                <img className={`collection-inner-banner--img ${!innerBanner.mobile_image_url ? 'collection-inner-banner--img-mobile-missing' : ''}`} src={`${window.baseAssetUrl}/${innerBanner.image_url}`} alt={stripped_title_label} />
                            </LazyLoad>
                            }
                            {innerBanner.only_image === "true" && innerBanner.mobile_image_url &&
                            <LazyLoad height={200} offset={100} once={true}>
                                <img className="collection-inner-banner--img-mobile" src={`${window.baseAssetUrl}/${innerBanner.mobile_image_url}`} alt={stripped_title_label} />
                            </LazyLoad>
                            }
                            {innerBanner.only_image === "false" &&
                            <>
                                {innerBanner.image_url && innerBanner.text_location !== "center" &&
                                <div className="collection-inner-banner--img-container">
                                    <LazyLoad height={200} offset={100} once={true}>
                                        <img className={`collection-inner-banner--img ${!innerBanner.mobile_image_url ? 'collection-inner-banner--img-mobile-missing' : ''}`} src={`${window.baseAssetUrl}/${innerBanner.image_url}`} alt={stripped_title_label} />
                                    </LazyLoad>
                                    {innerBanner.mobile_image_url &&
                                    <LazyLoad height={200} offset={100} once={true}>
                                        <img className="collection-inner-banner--img-mobile" src={`${window.baseAssetUrl}/${innerBanner.mobile_image_url}`} alt={stripped_title_label} />
                                    </LazyLoad>
                                    }
                                </div>
                                }
                                <div className="collection-inner-banner--details" style={{backgroundColor: innerBanner.background_color, backgroundImage: `url(${window.baseAssetUrl}/${innerBanner.text_specific_background_url}`}}>
                                    {innerBanner.eyebrow_label && <span className="collection-inner-banner--title" style={{color: innerBanner.eyebrow_label_color, fontSize: innerBanner.eyebrow_font_size, fontFamily: innerBanner.eyebrow_font_family, letterSpacing: innerBanner.eyebrow_letter_spacing}}>{ReactHtmlParser(innerBanner.eyebrow_label)}</span>}
                                    {innerBanner.title_label && <span className="collection-inner-banner--blurb" style={{color: innerBanner.title_label_color, fontSize: innerBanner.title_font_size, fontFamily: innerBanner.title_font_family, letterSpacing: innerBanner.title_letter_spacing}}>{ReactHtmlParser(innerBanner.title_label)}</span>}
                                    {innerBanner.text_label && <span className="collection-inner-banner--text" style={{color: innerBanner.text_label_color, fontSize: innerBanner.text_font_size, fontFamily: innerBanner.text_font_family, letterSpacing: innerBanner.text_letter_spacing}}>{ReactHtmlParser(innerBanner.text_label)}</span>}
                                    {innerBanner.cta_label &&
                                    <div className="collection-inner-banner--cta" style={{backgroundColor: innerBanner.cta_color, color: innerBanner.cta_label_color}}>
                                        {innerBanner.cta_label}
                                    </div>
                                    }
                                </div>
                            </>
                            }
                        </a>
                    </div>;
                }
            })
        }
    })

    return generatedBanner;
}

export default PLPInnerBanner;